<template>
    <div>
        <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
            <div v-if="this.isMobile">
                <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
            </div>
            <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
                {{ this.$store.state.modal.content.title }}
            </div>
            <div v-if="!this.isMobile">
                <Icon name="close" class="c24 pointer" @click="this.close()"/>
            </div>
        </div>
        <div class="p24 mb-0 content">
            <div class="d-flex flex-column gap16">
                <div>
                    <div class="d-flex align-items-center gap8">
                        <span class="fsp14 lh20 text-black neue-roman">
                            {{ this.$t('views.P2P.SingleSwap.4') }}
                        </span>
                        <span class="require"> *</span>
                    </div>
                    <Select 
                        class="m-0 mt-0"
                        :is_request="true" 
                        id='cancel_reason' 
                        :dataValue='this.cancel_reason'
                        :defaultValue="this.$t('views.P2P.SingleSwap.50')"
                        :keywords.sync='this.cancel_reasons' 
                        @updateParentState="this.updateState" 
                    />
                </div>
                <div>
                    <label class="fsp14 lh20 text-black neue-roman mb8 d-block">
                        {{ this.$t('views.P2P.SingleSwap.3') }}
                    </label>
                    <textarea
                        class="fsp14 lh20 neue wid border-full py10 px12 input-wrapper input-container textarea-height fw-medium textarea-min-height"
                        v-model="cancel_comment"
                        :placeholder="this.$t('views.P2P.SingleSwap.49')"
                    ></textarea>
                </div>
                <div class="neue-roman fsp14 lh20 text-black">
                    <div class="mb16">{{ $t('views.P2P.SingleSwap.46') }}</div>
                    <div>{{ $t('views.P2P.SingleSwap.47') }}</div>
                </div>
            </div>
            <div class="d-flex mt24" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
                <Button type="btn-outline-warning" class="equal-width h48 mr16 status-text-red border-full" @click="this.save()">{{ $t('views.P2P.SingleSwap.44') }}</Button>
                <Button type="btn-outline-grey" class="equal-width h48 primary-grey" @click="this.clearAll()">{{ $t('views.P2P.SingleSwap.45') }}</Button>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon'
import Button from '@/components/service/Button'
import Select from '@/components/service/Select'
import Input from '@/components/service/Input'

export default {
    name: 'CancelOrder',
    components: {
        Icon,
        Button,
        Select,
        Input
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            cancel_reason: '',
            cancel_comment: '',
            cancel_reasons: []
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.isMobile
        }
    },
    created() {
        this.getKeywords();
    },
    methods: {
        getKeywords() {
            this.axios.post('GetKeywords', {group: '151', no_loader: true}).then(res => {
                this.cancel_reasons = res.data.body;
            })
        },
        updateState(state) {
            this[state.id] = state.value;
        },
        save() {
            if (this.$store.state.modal.content.callback) {
                this.$store.state.modal.content.callback(this.cancel_reason, this.cancel_comment);
            }
            this.close();
        },
        clearAll() {
            this.close();
        }
    }
}
</script>
<style scoped lang="scss">
    textarea.textarea-min-height {
        min-height: 100px;
        
        &::placeholder {
            color: $primary-grey;
        }
    }
</style>
